import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import ScrollToTop from "./ScrollToTop";
import GAWrapper from "../analytics/GAWrapper";
import Consent from "../analytics/Consent";
import GAInitializer from "../analytics/GAInitializer";
import { PagePreviewProvider } from "../context/PageInfoContext";
import QueryParamsHandler from "../components/QueryParamsHandler";

export default function App() {
  	return (
		<PagePreviewProvider>
			<BrowserRouter>
				<ScrollToTop />
				<QueryParamsHandler />
				<Consent />
				<GAInitializer />
				<GAWrapper>
					<Router />
				</GAWrapper>
			</BrowserRouter>
		</PagePreviewProvider>
  	);
}